<div class="correction-tool">
  <div class="is-flex is-justify-content-space-between is-align-items-center px-2">
    <div class="is-flex">
      <button
        fino-button
        type="button"
        icon="Move Left 1"
        (click)="shrinkPdfSpace()"
        class="mr-1"
        title="Shrink PDF"
      ></button>
      <button
        fino-button
        type="button"
        icon="Move Right 1"
        class="mr-4"
        (click)="growPdfSpace()"
        title="Grow PDF"
      ></button>
      <button
        fino-button
        type="button"
        icon="Rotate Horizontal"
        (click)="switchPDFTableOrientation()"
        title="Grow PDF"
      ></button>
    </div>

    <div class="tenant-info">
      <strong>Correction ID:</strong> {{ currentDocument()?.correction?._id }}
      <strong class="ml-2">Original ID:</strong>
      {{ currentDocument()?.correction?.originalTransactionListId }}
      <strong class="ml-2">Tenant:</strong> {{ currentDocument()?.correction?.tenant }}
    </div>
  </div>

  <div
    class="is-flex is-fullwidth is-fullheight"
    [class.is-flex-direction-column]="tableAndDocumentStacked"
  >
    <div
      [style.width.%]="tableAndDocumentStacked ? 100 : leftWidth"
      [style.height.%]="tableAndDocumentStacked ? leftWidth : 100"
    >
      <div class="pdf-controls">
        <button fino-button type="button" (click)="previousPage()" title="Previous Page">←</button>
        <input
          type="number"
          [ngModel]="currentPageNum()"
          (ngModelChange)="onPageInputChange($event)"
          [min]="1"
          [max]="totalPages()"
          class="page-input"
        />
        <span class="page-separator">/ {{ totalPages() }}</span>
        <button fino-button type="button" (click)="nextPage()" title="Next Page">→</button>
      </div>
      <div class="is-fullheight">
        @if (pdfUrl()) {
          <ng2-pdfjs-viewer
            #pdfViewer
            [pdfSrc]="pdfUrl()"
            [showSpinner]="false"
            (onDocumentLoad)="onPdfLoaded($event)"
            cursor="hand"
            (onPageChange)="onPdfPageChange($event)"
          >
          </ng2-pdfjs-viewer>
        } @else {
          <div class="has-text-centered p-4">Loading PDF...</div>
        }
      </div>
    </div>

    <div class="divider" (mousedown)="startDragging($event)"></div>

    <div
      [style.width.%]="tableAndDocumentStacked ? 100 : 100 - leftWidth"
      [style.height.%]="tableAndDocumentStacked ? 100 - leftWidth : 100"
    >
      <div class="table-panel">
        @if (!documentLoading() && !currentDocument()) {
          <article class="message is-warning">
            <div class="message-body">No more documents available for correction.</div>
          </article>
        }

        @if (currentDocument()) {
          <app-correction-table
            [enrichedData]="
              currentDocument()?.correction?.correctedData ??
              currentDocument()?.correction?.extractedData
            "
            [currentPageNum]="currentPageNum()"
            [threshold]="threshold"
          ></app-correction-table>

          @if (isCurrentCorrectionActionable) {
            <div class="box submit-footer mt-2">
              <form [formGroup]="loadNextDocumentForm">
                <fino-checkbox formControlName="loadNext" label="identifyDocument.loadNext">
                </fino-checkbox>
              </form>

              <button
                fino-button
                type="button"
                (click)="skipDocument()"
                [loading]="submitting()"
                class="skip-btn"
              >
                Skip Document
              </button>

              <button
                fino-button
                type="button"
                class="ml-2"
                (click)="openSendToReviewModal()"
                data-testid="send-to-review-action"
              >
                Send to Review
              </button>

              <button
                [loading]="submitting()"
                fino-button
                [primary]="true"
                class="ml-2"
                (click)="submitCorrection()"
              >
                Submit Correction
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>

  @if (showSendToReviewModal()) {
    <div class="review-modal-backdrop">
      <div class="review-modal">
        <h3 class="title is-size-5 mb-2">Send to Review</h3>
        <p class="mb-3">Please add a review comment.</p>

        <fino-textarea [formControl]="reviewCommentControl" label="comment"></fino-textarea>

        <div class="is-flex is-justify-content-end mt-4">
          <button
            fino-button
            type="button"
            class="mr-2"
            (click)="closeSendToReviewModal()"
            [disabled]="reviewSubmitting()"
          >
            Cancel
          </button>
          <button
            fino-button
            type="button"
            [primary]="true"
            (click)="confirmSendToReview()"
            [disabled]="reviewSubmitting()"
            [loading]="reviewSubmitting()"
            data-testid="send-to-review-confirm"
          >
            Send to Review
          </button>
        </div>
      </div>
    </div>
  }
</div>
